<template>
  <div class="dormitory">
    <!-- 操作栏容器 -->
    <div class="dormitory-info-operation-container">
      <div class="notice-search">
        <search :placeholder="placeholder" @search="search" />
        <div class="select">
          <el-select v-model="dormData.dormType" placeholder="宿舍规格" @change="getDormList" clearable>
            <el-option :label="item.dictLabel" :value="item.dictValue" v-for="(item, index) in dictTypeList"
              :key="index"></el-option>
          </el-select>
        </div>
      </div>
      <div class="dorm-info-button-container">
        <!-- 新增学生 -->
        <button class="button add-dorm" @click="dormFormShow = true" v-hasPermi="'sc:dorm:add'">
          <i class="iconfont icon-addGlade"></i>新增宿舍
        </button>
        <!-- 批量删除 -->
        <button class="button delete-dorm" @click="deleteClick" v-hasPermi="'sc:dorm:delete'">
          <i class="iconfont icon-delete" />批量删除
        </button>
        <!-- 学生退宿 -->
        <button class="button delete-dorm" @click="retreat">
          <i class="iconfont icon-studentManagement" />学生退宿
        </button>
      </div>
    </div>
    <!-- 列表栏容器 -->
    <div class="dormitory-info-table-container" v-bitmap="dormitoryListGetResult">
      <dormitoryList class="dormitory-list" :dormitoryData="dormitoryData" v-show="total"
        @multipleDelete="multipleDelete" @changeDorm="changeDorm" :dictTypeList="dictTypeList" />
    </div>
    <!-- 分页容器 -->
    <div class="dormitory-info-pagination-catainer">
      <pagination :total="parseInt(total)" :pageSize="parseInt(pageInfo.pageSize)"
        @currentPageNumChange="currentPageNumChange" @handleSizeChange=handleSizeChange />
    </div>
    <!-- 添加宿舍-表单 -->
    <addDormForm :dormFormShow.sync="dormFormShow" v-show="dormFormShow" ref="addDormForm" @formSubmit="formSubmit"
      :dictTypeList="dictTypeList" />
    <!-- 一键更换宿舍 -->
    <changeDorm :changeShow.sync="changeShow" v-if="changeShow" :dormitoryChangeData="dormitoryChangeData" :dormInfo="dormInfo" />
  </div>
</template>

<script>
import dormitoryList from "./components/dormitory-list/dormitoryList.vue";
import addDormForm from "./components/adddorm-form/adddorm-form.vue";
import search from "@/components/search/search.vue";
import changeDorm from "./components/change-dorm/change-dorm.vue";
export default {
  data() {
    return {
      dormitoryListGetResult: "nullData",
      pageInfo: {
        pageSize: 10,
        pageNum: 1,
      },
      dormitoryData: [],
      dormData: {
        inFull: 0,
        blockName: "",
        level: "",
        dormType: "",
        dormName: "",
      },
      total: 0,
      dormFormShow: false,
      deleteList: [],
      dictTypeList: [],
      placeholder: "请输入宿舍编号",
      dormInfo: null,
      changeShow: false,
      dormitoryChangeData: []
    };
  },
  components: {
    dormitoryList,
    addDormForm,
    search,
    changeDorm
  },
  provide() {
    return {
      refresh: this.refresh,
    };
  },
  created() {
    this.getDormList();
    this.getDictType();
  },
  methods: {
    changeDorm(row) {
      this.dormInfo = row;
      this.get(this.$url.getDormList, {
        dormType: row.dormType,
      })
        .then((res) => {
          // console.log("宿舍列表==>", res);
          if (res.code != 200) {
            return this.$message.error("获取宿舍列表失败");
          }
          this.dormitoryChangeData = res.rows;
          this.changeShow = true;
        })
        .catch((err) => {
          return;
        });
    },
    getDictType() {
      this.get(`${this.$url.getDictType}/dorm_type`).then((res) => {
        // console.log("宿舍规格==>", res);
        this.dictTypeList = res.data;
      });
    },
    formSubmit(data) {
      const { blockName, dormName, dormType, level } = data;
      this.post(this.$url.addDorm, {
        schoolId: this.user.schoolId,
        dormName,
        dormType,
        blockName,
        level,
      }).then((res) => {
        // console.log("新增宿舍==>", res);
        if (res.code != 200) {
          return this.$message.error(res.msg);
        }
        this.$message.success("添加成功");
        this.$refs.addDormForm.reset();
        this.dormFormShow = false;
        this.refresh();
      });
    },
    multipleDelete(res) {
      this.deleteList = res;
    },
    // 学生退宿
    retreat() {
      if (!this.deleteList.length) {
        return this.$message.warning("请先选择需要进行退宿的宿舍");
      }
      this.$confirm("是否为该宿舍的所有学生办理退宿?", "学生退宿", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        confirmButtonClass: "confirm",
      })
        .then(() => {
          // 调用删除接口
          this.delete(this.$url.deleteBindByDormIds + "/" + this.deleteList)
            .then((res) => {
              // console.log(res);
              if (res.code == 200) {
                this.$message.success("退宿成功");
                // 刷新列表
                this.refresh();
              } else {
                this.$message.error(res.msg);
              }
            })
            .catch((err) => {
              // this.$message.error("退宿失败，请稍后重试");
            });
        })
        .catch(() => { });
    },
    // 批量删除
    deleteClick() {
      if (!this.deleteList.length) {
        return this.$message.warning("请先选择需要删除的宿舍");
      }
      this.$confirm("是否删除选中的宿舍?", "删除宿舍", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        confirmButtonClass: "confirm",
      })
        .then(() => {
          // 调用删除接口
          this.delete(this.$url.delDorm + "/" + this.deleteList)
            .then((res) => {
              // console.log(res);
              if (res.code == 200) {
                this.$message.success("删除成功");
                // 刷新列表
                this.refresh();
              }
            })
            .catch((err) => {
              this.$message.error("删除失败，请稍后重试");
            });
        })
        .catch(() => { });
    },
    // 分页组件传递过来的页码修改事件
    currentPageNumChange(pageNum) {
      this.pageInfo.pageNum = pageNum;
      this.getDormList();
    },
    handleSizeChange(pageSize) {
      this.pageInfo.pageSize = pageSize;
      this.getDormList();
    },
    // 刷新
    refresh() {
      this.pageNum = 1;
      this.total = 0;
      this.dormitoryData = [];
      this.getDormList();
    },
    search(query) {
      this.dormData.dormName = query;
      // 刷新
      this.refresh();
    },
    // 获取宿舍列表
    getDormList() {
      // this.dormitoryListGetResult = "loading";
      const { inFull, blockName, level, dormType, dormName } = this.dormData;

      this.get(this.$url.getDormList, {
        inFull,
        blockName,
        level,
        dormType,
        dormName,
        pageNum: this.pageInfo.pageNum,
        pageSize: this.pageInfo.pageSize,
      })
        .then((res) => {
          // console.log("宿舍列表==>", res);
          if (res.code != 200) {
            this.dormitoryListGetResult = "error";
            return this.$message.error("获取宿舍列表失败");
          }
          this.total = res.total;
          this.total > 0
            ? (this.dormitoryListGetResult = "success")
            : (this.dormitoryListGetResult = "nullData");
          if (this.total === 0) {
            this.dormitoryListGetResult = "nullData";
            return this.$message.warning("暂无宿舍列表");
          }
          this.dormitoryData = res.rows;
        })
        .catch((err) => {
          this.$message.error("获取宿舍列表失败");
          this.dormitoryListGetResult = "error";
          return;
        });
    },
  },
};
</script>

<style scoped lang="scss">
@import "./dormitory.scss";
</style>
